import React from 'react';
import FlowABTestFeature from '../FlowABTestFeature';
import NewFeature from './NewFeature';

const NewFlowLandingFeatures = ({
  streamLandingSettings: { main_settings_block: mainSettingsBlock },
  currentLandingSettings = {},
  onFeaturesChange,
  isStreamTikTok,
  abEnabled,
  onOverridesChange,
  currentLandingSettingsOverrides,
}) => {
  const handleChange = (path, value) => {
    onFeaturesChange((draft) => {
      draft[path] = value;
      return draft;
    });
  };

  const handleGroupChange = (path, value) => {
    onFeaturesChange((draft) => {
      if (value === false) {
        for (let key in draft) {
          if (key.includes(path)) {
            delete draft[key];
          }
        }
      } else {
        draft[path] = value;
      }
      return draft;
    });
  };

  const handleGroupSelectChange = (path) => {
    onFeaturesChange((draft) => {
      for (let key in draft) {
        if (key.includes(path)) {
          delete draft[key];
        }
      }
      return draft;
    });
  };

  const handleSettingsModification = (mutatorFunction) => {
    onOverridesChange((draft) => mutatorFunction(draft));
  };

  return (
    <div className="landings-features">
      <ul className="feature-list">
        <li>
          <FlowABTestFeature selected={abEnabled} />
        </li>
        {mainSettingsBlock &&
          mainSettingsBlock.map((el) =>
            // remove "Your contacts" group when "Stream for TikTok" checked
            isStreamTikTok && el.id === 4 ? null : (
              <li key={el.title}>
                <NewFeature
                  {...el}
                  handleChange={handleChange}
                  handleGroupChange={handleGroupChange}
                  handleGroupSelectChange={handleGroupSelectChange}
                  stateOfThings={currentLandingSettings}
                  parentPath={`main_settings_block`}
                  handleSettingsModification={handleSettingsModification}
                  currentLandingSettingsOverrides={currentLandingSettingsOverrides}
                />
              </li>
            ),
          )}
      </ul>
    </div>
  );
};

export { NewFlowLandingFeatures };
